<!-- Light/Dark Mode Button -->
<!-- <button type="button" class="light-dark-toggle leading-none inline-block transition-all text-[#fe7a36] fixed top-1/2 -translate-y-1/2 ltr:left-[20px] rtl:right-[20px] ltr:md:left-[25px] rtl:md:right-[25px] z-[9999]" (click)="toggleTheme()">
    <i class="material-symbols-outlined !text-[20px] md:!text-[22px]">
        light_mode
    </i>
</button> -->

<div class="overflow-x-hidden min-h-screen flex flex-col justify-between bg-white">

    <app-fp-navbar />
    
    <main class="grow">
        <router-outlet />
    </main>

    <app-fp-footer />

</div>